import React, {useState} from 'react'
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { updateInformation } from '../../actions/auth';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import ProfileImage from "@daym3l/react-profile-image";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import './index.css';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const InfoForm = ({user}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  
  const [open, setOpen] = React.useState(false);
  const [personalInformation, setPersonalInformation] = useState({firstName: user?.result.name.split(" ")[0], lastName: user?.result.name.split(" ")[1] , email: user?.result.email, newPassword: "", collegeYear: user?.result.collegeYear, major: user?.result.major  , collegeName: user?.result.collegeName, image: user?.result.image, newPassword: ''});
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  
  const handleSubmit = (event) =>{
    event.preventDefault();
    dispatch(updateInformation(personalInformation));
    setOpen(true);
  };
  
  const handleChange = (e) => {
    setPersonalInformation({...personalInformation, [e.target.name]: e.target.value});
  };

  const getImages = (base64Image, fileImage) => {
		setPersonalInformation({...personalInformation, image: base64Image})
	};

  return (
        <div>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="success">
              Your profile has been updated!
            </Alert>
          </Snackbar>
          <br />
          <br />
          <Container>      
            <Row>
              <Col sm= {4}>
                <Form type = "submit">
                  <Row>
                    <Col sm = {2}>
                    </Col> 
                    <Col>
                      <ProfileImage
                        camera
                        returnImage={getImages}
                        defaultImage = {user?.result?.image}
                        uploadBtnProps={{ variant: "contained", label: "Browse" }}
                        styles = {{ height: 200, width: 200, backgorundColor: '#87ceeb', borderRadius: '250px'}}
                      />
                    </Col>  
                  </Row>
                  <br /> 
                  <Row> 
                    <Col>
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control name = "firstName" value = {personalInformation.firstName} onChange = {handleChange} />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control name = "lastName" value = {personalInformation.lastName} onChange = {handleChange}/>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group controlId="formGroupEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control disabled name = "email" type="email" value = {personalInformation.email} />
                  </Form.Group>
                  <Form.Group controlId="formGroupPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control name = "newPassword" type="password" placeholder = "*********" value = {personalInformation.newPassword} onChange = {handleChange}/>
                  </Form.Group>
                  <Form.Group controlId="formGroupEmail">
                    <Form.Label>Major</Form.Label>
                    <Form.Control name = "major" value = {personalInformation.major} onChange = {handleChange}/>
                  </Form.Group>
                  <Form.Group controlId="formGroupEmail">
                    <Form.Label>Year In College</Form.Label>
                    <Form.Control name = "collegeYear" value = {personalInformation.collegeYear} onChange = {handleChange}/>
                  </Form.Group>
                  <Form.Group controlId="formGroupEmail">
                    <Form.Label>College's Name</Form.Label>
                    <Form.Control name = "collegeName" value = {personalInformation.collegeName} onChange = {handleChange}/>
                  </Form.Group>
                  <br />
                  <Button onClick = {() => {history.push('/homepage')}} variant="outline-danger">Cancel</Button> {'  '}
                  <Button onClick = {handleSubmit} variant="outline-primary">Update</Button>
                </Form>
              </Col>
              <Col sm = {8}>
              </Col>
            </Row>
          </Container>
      </div>
    )
}

export default InfoForm
